// eslint-disable-next-line import/no-extraneous-dependencies
import 'amfe-flexible';
import Vue from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
// import VConsole from 'vconsole';
import { Toast, Dialog, Icon } from 'vant';
import { initStoreValue } from '@/store/initStoreValue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/mixins/index';

import '@/styles/index.scss';

// eslint-disable-next-line import/no-extraneous-dependencies,import/order
// import VConsole from 'vconsole';

// eslint-disable-next-line no-unused-vars
// const vConsoleI = new VConsole();
// eslint-disable-next-line import/order
// import { getDelQKeyUrl } from '@/utils/url';

Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Icon);

initStoreValue();

// eslint-disable-next-line no-new,no-unused-vars
// const vConsole = new VConsole();
// console.log(getDelQKeyUrl('https://monitor.api.vvfly.cn/h5/wx/index.html?code=031CqwGa1mLb7G00CsJa1Fl5Nj1CqwGs&state=1&zzz=20#/ya50Wish?cccc=10'), '---');

// 需要 VConsole
// && process.env.NODE_ENV !== 'development'
if (process.env.VUE_APP_VCONSOLE) {
    try {
        // eslint-disable-next-line import/no-extraneous-dependencies
        import('vconsole').then((VConsole) => {
            // eslint-disable-next-line no-unused-vars,new-cap
            const vConsoleI = new VConsole.default();
        });
    } catch (e) {
        console.error(e);
    }
}

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');

console.log('打包时间', process.env.__Package_Time__);
console.log('版本', process.env.__version__);
